// 정적 외부/서비스 URL SSOT. 환경 무관 고정값만 둔다 (환경별로 갈리면 `@/env` 로 승격).
// 외부 링크 열기 분기(web window.open / native app.openExternal)는 Navigator 가 담당.

import { getAppType } from '@/shared/bridge';
import { isApplePlatform } from './platform';

/**
 * 앱 커스텀 스킴 — `apps/native/app.config.ts` 의 `scheme` 과 **같은 값이어야 한다**(빌드가 갈라져 있어
 * 타입으로 묶을 수 없으니 바꿀 때 양쪽을 함께 고칠 것). 딥링크 URL 조립(`/open` 폴백 화면)이 쓴다.
 */
export const APP_SCHEME = 'heviton';

export const EXTERNAL_LINKS = {
  /** 고객센터 채널톡 (브랜드 단일 워크스페이스). */
  CHANNELTALK: 'https://p6lzz.channel.io/home',
  /**
   * 헤빛온 앱 다운로드 — Play 스토어(안드로이드). **직접 쓰지 말 것** — web 화면의 앱 유도 링크는
   * 방문 기기에 맞는 스토어로 보내야 하므로 `appDownloadUrl()` 을 쓴다(이 상수는 그 함수의 분기 항).
   */
  APP_DOWNLOAD: 'https://play.google.com/store/apps/details?id=com.herit.heviton&hl=ko',
  /** 헤빛온 App Store(iOS) — id 기반 canonical 형태. 이름 slug 는 앱 표시명이 바뀌면 깨지므로 쓰지 않는다. */
  APP_DOWNLOAD_IOS: 'https://apps.apple.com/kr/app/id6757730865',
  /** 헤빛온 웹(REMS) 홈 — 레거시 운영 웹 로그인. 환경별로 갈리면 `@/env` 로 승격(TODO). */
  REMS_HOME: 'https://rems.heviton.com/login',
} as const;

/**
 * **실행 중인 플랫폼**의 스토어 URL — 강제 업데이트처럼 "지금 이 앱을 갱신"시켜야 할 때 쓴다.
 * web 에서 부를 일은 없지만(업데이트=새로고침) 호출되면 Play 스토어로 접는다 — 안드로이드 유입이 기본이라.
 */
export function appStoreUrl(): string {
  return getAppType() === 'ios' ? EXTERNAL_LINKS.APP_DOWNLOAD_IOS : EXTERNAL_LINKS.APP_DOWNLOAD;
}

/**
 * **web 화면의 앱 유도 링크** — 방문 기기에 맞는 스토어로 보낸다.
 * Apple 계열(iOS·macOS)은 App Store, 그 외(Android·Windows·Linux)는 Play 스토어.
 *
 * 버튼 자체의 노출 여부는 호출처가 `isMobileBrowser()` 로 가른다 — 데스크톱에선 설치가 안 되므로.
 */
export function appDownloadUrl(): string {
  return isApplePlatform() ? EXTERNAL_LINKS.APP_DOWNLOAD_IOS : EXTERNAL_LINKS.APP_DOWNLOAD;
}
